import { ButtonDef } from "../core/form/ButtonDef";
import { useData, useDataValue } from "../core/hooks/useData";
import { IconChoice as BaseIconChoice } from "../core/ui/IconChoice"
import { IconChoiceElement } from "./types";

export function IconChoice(props: {
	prop: string,
	items: any[],

	def: IconChoiceElement,

    getValue: (item: any, specificColumn?: string) => any;
    getDisplay: (item: any, selected: boolean) => any;
}) {

	const data = useData();
	const value = useDataValue(data, props.prop);

	const options: ButtonDef[] = [];
	for(let item of props.items) {
		const id = props.getValue(item);
		const selected = (value === id);
		options.push({
			id,
			title: props.getDisplay(item, selected),
			icon: props.getValue(item, props.def.iconCol),
			selected,
		})
	}

	return (
		<BaseIconChoice 
			options={options}
			onChoose={(option) => {
				data.setValue(props.prop, option.id);
			}}
		/>
	);
}